import {OptionProps} from "antd/lib/select";

export enum VAT {
  P27 = 'P27',    // 27%
  P0 = 'P0',      // 0%
  FAFA = 'FAFA',  // Forditott AFA
  MAA = 'MAA',    // Mentes az ado alol
}

export const vatTypeToText = {
  [VAT.P27]: '27%',
  [VAT.P0]: '0%',
  [VAT.FAFA]: 'F.ÁFA',
  [VAT.MAA]: 'MAA',
};

export function getVatOptions(): OptionProps[] {
  return Object.keys(VAT)
    .map(type => ({value: type, key: type, title: vatTypeToText[type]}));
}


// WEBPACK FOOTER //
// ./src/common/vat.tsx